/*
 * Sepet çekmecesinin ALT BLOĞUNU (toplam + "Sipariş detayları" + ödeme) takılı
 * kalan saydamlıktan kurtarır.
 *
 * SORUN (saha 2026-09-13): sepet boşken çekmece içinden bir ürün eklenince satır,
 * kargo barı ve öneriler geliyor ama alt blok GÖRÜNMÜYOR; yalnız sayfa yenilenince
 * çıkıyor.
 *
 * NEDEN: tema sepet boşaldığında (`cart-drawer.js` → `replaceContent`) gövdeyi ve
 * alt bloğu birlikte söndürüyor, sonra YALNIZ gövdeyi geri açıyor:
 *
 *     if (itemCount === 0) {
 *       timeline([[body, {opacity:[1,0]}], [footer, {opacity:[1,0], …}]])
 *       … replaceChildren(…)
 *       animate(body, {opacity:[0,1], …})        // footer geri AÇILMIYOR
 *     }
 *
 * Boş sepette alt blok zaten basılmadığı için bu doğru. Ama sönük hâl gölge
 * kökteki `[part="footer"]` üstünde KALIYOR. Sonra çekmece AÇIKKEN içeriden ürün
 * eklenirse (öneri şeridindeki "Sepete ekle") sepet 0→1 olur, içerik değişir, ama
 * çekmece kapanıp açılmadığı için `dialog:before-show` hiç tetiklenmez — temanın
 * alt bloğu geri açan tek yolu orasıdır. Sonuç: dolu sepette görünmez alt blok.
 *
 * ÇÖZÜM: temanın kendi `cart-drawer:refreshed` olayına bağlanıp, içerik gerçekten
 * alt blok taşıyorsa sönük hâli temizlemek. Satıcı paketine (theme.js) DOKUNULMAZ;
 * tema güncellemesi bu dosyayı ezmez.
 */
(() => {
  const isDrawerEmpty = (drawer) => !drawer.querySelector('[slot="footer"]');

  const restoreFooter = (drawer) => {
    const footer = drawer.shadowRoot?.querySelector('[part="footer"]');
    if (!footer) return;

    // Sepet BOŞSA dokunma: alt blok yok, temanın sönük bırakması doğru.
    if (isDrawerEmpty(drawer)) return;

    // Sönüklük iki yoldan gelebiliyor: satır-içi stil (`style.opacity = "0"`) ve
    // biten animasyonun tuttuğu son kare. Satır-içi stil tek başına yetmez —
    // animasyon basamağı katmanda ondan ÜSTTE durur, o yüzden önce iptal edilir.
    footer.getAnimations?.().forEach((animation) => animation.cancel());
    footer.style.removeProperty('opacity');
    footer.style.removeProperty('transform');
  };

  document.addEventListener('cart-drawer:refreshed', (event) => {
    const drawer = event.target;
    if (drawer?.tagName?.toLowerCase() !== 'cart-drawer') return;
    // İçerik yeni değişti; tema kendi animasyonunu kurduysa ondan SONRA temizle.
    requestAnimationFrame(() => restoreFooter(drawer));
  });
})();
